import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SegmentInformationComponent } from './segment-information.component';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { DetailsButtonModule } from '../../components/details-button/details-button.module';
import { IfScreenSizeModule } from '../../directives/if-screen-size/if-screen-size.module';
import { DateFormatModule, MetaUrlModule, PopupIndicatorPipeModule, StaticMsgModule } from '@lib/pipes';
import { AirportNamePipeModule } from '../../pipes/airport-name/airport-name.module';
import { IndicatorPopupModule, TextTooltipModule } from '@lib/components';

@NgModule({
  declarations: [SegmentInformationComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    StaticMsgModule,
    DetailsButtonModule,
    IfScreenSizeModule,
    DateFormatModule,
    AirportNamePipeModule,
    TextTooltipModule,
    PopupIndicatorPipeModule,
    MetaUrlModule,
  ],
  exports: [SegmentInformationComponent],
})
export class SegmentInformationModule {}
